<template>
  <div class="sidebar-info-item">
    <div class="sidebar-info-header">
      {{ $t(headerText) }}
    </div>
    <div class="sidebar-info-body">
      <div class="sidebar-info-body-text">
        <slot />
      </div>
      <Button
        class="sidebar-info-body-button"
        :label="$t(buttonText)"
        @click="moreInfo"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "SidebarInfoItem",
  props: {
    headerText: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      default: '',
    }
  },
  methods: {
    moreInfo() {
      this.$emit('more-info')
    }
  }
}
</script>

<style scoped lang="scss">
.sidebar-info-item {
  padding-top: 8px;
  position: relative;

  &:not(:last-child) {
    border-bottom: 1px solid #E9E9E9;
  }

  .sidebar-info-header {
    display: flex;
    justify-content: space-between;
    position: relative;
    margin-right: 5px;
    margin-bottom: 3px;
    font-weight: 400;
    font-size: 10px;
    color: #9b9b9b;
  }

  .sidebar-info-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30px;
    margin-bottom: 12px;

    &-text {
      display: flex;
      font-weight: 600;
      font-size: 22px;
      line-height: 30px;
      color: #595959;
      text-transform: uppercase;
      span {
        margin-left: 8px;
      }
    }
    &-button {
      font-weight: 400;
      font-family: Roboto, Tahoma, Arial, sans-serif;
      font-size: 12px !important;
      line-height: 16px !important;
      width: 80px;
      height: 26px;
      background-color: #40bd5e;
      border: none;
      padding: 0 10px;

      &:hover {
        background-color: #29b344;
      }
    }
  }

  &.sidebar-info-coins .sidebar-info-body-button {
    background-color: #ffbe00;
    &:hover {
      background-color: #ffcc37;
    }
  }
}
</style>
